module.exports = __webpack_public_path__ + "img/3.c5d84c0d.jpg";